import React from 'react';
import { connect } from 'react-redux';
import { ContentIcon } from './shared/ContentIcon';
import { ContentType } from 'constants/types';
import { groupsByIdSelector } from 'selectors/groups';
import { KpiParameterSelect } from './shared/KpiParameterSelect';

class KpiEntryItemFormBase extends React.PureComponent {
  handleRemove = () => this.props.onRemove(this.props.id);

  render() {
    const {
      id,
      parameterAssignment,
      parameters,
      onChange,
      groupsById,
    } = this.props;

    const hasAssignedParameter = !!parameterAssignment.parameter;
    const parameterSelectValue =
      (hasAssignedParameter && parameterAssignment.parameter) || null;

    const parameterAssignmentGroup = groupsById[parameterAssignment.contentId];
    const parameterAssignmentcgroupId =
      !!parameterAssignmentGroup && parameterAssignmentGroup.cgroupId;

    return (
      <tr>
        <td className="description">
          <ContentIcon
            isGroup={parameterAssignment.contentType === ContentType.group}
            cgroupId={parameterAssignmentcgroupId}
          />
          {parameterAssignment.contentDescription}
        </td>
        <td className="parameter">
          <KpiParameterSelect
            name="parameter"
            parameters={parameters}
            parameter={parameterSelectValue}
            onChange={({ target }) => onChange(id, target.value)}
          />
        </td>
        <td className="remove">
          <button type="button" onClick={this.handleRemove}>
            ×
          </button>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    groupsById: groupsByIdSelector(state),
  };
}

export const KpiEntryItemForm = connect(mapStateToProps)(KpiEntryItemFormBase);
